import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { getCurrentUser } from './auth';
import { CartProvider } from './context/CartContext';
import AuthLayout from './components/AuthLayout';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import ConfirmEmailPage from './pages/ConfirmEmailPage';
import ForgotPasswordPage from './pages/ForgotPasswordPage';
import CatalogPage from './pages/CatalogPage';
import CoursesPage from './pages/CoursesPage';
import CourseDetailPage from './pages/CourseDetailPage';
import LessonPage from './pages/LessonPage';
import CartPage from './pages/CartPage';
import OrdersPage from './pages/OrdersPage';
import ProfilePage from './pages/ProfilePage';
import { fetchUserProfile } from './api/users';
import ContactsPage from './pages/ContactsPage';
import LegalPage from './pages/LegalPage';
import Footer from './components/Footer';
import CookieBanner from './components/CookieBanner';
import './i18n';
import './amplify-config';

function RequireAuth({ children }) {
  const [authed, setAuthed] = useState(null);
  useEffect(() => {
    getCurrentUser()
      .then(() => {
        fetchUserProfile().catch(() => {});
        setAuthed(true);
      })
      .catch(() => setAuthed(false));
  }, []);
  if (authed === null) return null;
  return authed ? <AuthLayout>{children}</AuthLayout> : <Navigate to="/login" replace />;
}

export default function App() {
  return (
    <CartProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/confirm-email" element={<ConfirmEmailPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/catalog" element={<RequireAuth><CatalogPage /></RequireAuth>} />
          <Route path="/courses" element={<RequireAuth><CoursesPage /></RequireAuth>} />
          <Route path="/courses/:courseId" element={<RequireAuth><CourseDetailPage /></RequireAuth>} />
          <Route path="/courses/:courseId/lessons/:lessonId" element={<RequireAuth><LessonPage /></RequireAuth>} />
          <Route path="/cart" element={<RequireAuth><CartPage /></RequireAuth>} />
          <Route path="/orders" element={<RequireAuth><OrdersPage /></RequireAuth>} />
          <Route path="/profile" element={<RequireAuth><ProfilePage /></RequireAuth>} />
          <Route path="/contacts" element={<ContactsPage />} />
          <Route path="/agb" element={<LegalPage src="/legal/agb.html" />} />
          <Route path="/gdpr" element={<LegalPage src="/legal/gdpr.html" />} />
          <Route path="/impressum" element={<LegalPage src="/legal/impressum.html" />} />
          <Route path="*" element={<Navigate to="/catalog" replace />} />
        </Routes>
        <Footer />
        <CookieBanner />
      </BrowserRouter>
    </CartProvider>
  );
}
